import React from 'react';
import {
  StackLayout,
  StackItem,
  HeadingText,
  ParagraphText,
  Image,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { BENEFITS_MODULE_ASSET_KEYS } from '../../asset-map';

interface IdCardErrorProps {
  className?: string;
  title?: string;
  description?: string;
}

export function IdCardError({
  className,
  title,
  description,
}: IdCardErrorProps) {
  const ERROR_IMAGE = useStaticAsset(
    BENEFITS_MODULE_ASSET_KEYS.ID_CARD_ERROR,
  ) as string;

  return (
    <StackLayout
      className={className}
      spacing="$oneAndHalf"
      css={{
        padding: '$two',
        textAlign: 'center',
        backgroundColor: '$surfaceCardDisabled',
        borderRadius: '$card',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Image src={ERROR_IMAGE} alt="" width={140} loading="lazy" />
      <StackLayout spacing="$one" css={{ alignItems: 'center' }}>
        <StackItem>
          <HeadingText level="3" size="md" css={{ textAlign: 'center' }}>
            {title}
          </HeadingText>
        </StackItem>
        <StackItem>
          <ParagraphText
            css={{ textAlign: 'center', color: '$onSurfaceTextSubtle' }}
          >
            {description}
          </ParagraphText>
        </StackItem>
      </StackLayout>
    </StackLayout>
  );
}
